import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    error: {
      paddingLeft: theme.spacing(3.3),
      width: '100vw',
    },
    errorIcon: {
      color: theme.palette.error.main,
      marginTop: theme.spacing(1.75),
      marginLeft: theme.spacing(1.25),
      marginBottom: theme.spacing(3.75),
    },
    dialogBox: {
      padding: theme.spacing(4, 0, 8),
    },
    cardErrorTypography: {
      paddingLeft: theme.spacing(1.25),
    },
    cardErrorContainer: {
      display: 'flex',
      alignItems: 'center',
      background: '#FCFAFA',
      border: '1px solid #F1D5D1',
      borderRadius: 4,
      alignSelf: 'stretch',
      width: '100%',
      minHeight: theme.spacing(8),
      marginBottom: theme.spacing(3),
    },
    needHelp: {
      alignSelf: 'flex-end',
      borderTop: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(35.5),
      paddingTop: theme.spacing(3),
      width: '100%',
    },
    needHelpWrapper: {
      display: 'flex',
      minHeight: '33vh',
      padding: theme.spacing(0, 3, 3),
      width: '100%',
    },
    questionLabelContainer: {
      paddingLeft: theme.spacing(2),
    },
    questionLabel: {
      fontSize: 12,
    },
    container: {
      paddingLeft: theme.spacing(4),
    },
    fields: {
      marginBottom: theme.spacing(10),
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(6),
      },
    },
    field: {
      marginBottom: theme.spacing(3),
    },
    helpText: {
      marginBottom: theme.spacing(10),
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(6),
      },
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    primaryButton: {
      marginLeft: theme.spacing(2),
    },
    passwordResetButtons: {
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(3),
        marginRight: theme.spacing(0),
      },
      [theme.breakpoints.up('md')]: {
        paddingBottom: theme.spacing(0),
        marginRight: theme.spacing(3),
      },
    },
    passwordResetButtonsGrid: {
      [theme.breakpoints.down('md')]: {
        display: 'inline-table',
      },
      [theme.breakpoints.up('md')]: {
        display: 'inline-flex',
      },
    },
  })
);
